import SelectedEntity from './SelectedEntityContext';
import PerformanceBoardSlideOutContext from './PerformanceBoardSlideOutContext';

const PerformanceBoardContexts = {
  SelectedEntity,
  PerformanceBoardSlideOutContext,
};

export default PerformanceBoardContexts;
